import { NonIndexRouteObject } from "react-router-dom";
import {
  OutsourcingServicesPage,
  LandingPage,
  OfferPage,
  PrivacyPage,
  KnowledgeBasePage,
} from "src/pages";
import { ErrorBoundary } from "src/pages/ErrorBoundary";
import { NotFound } from "src/pages/ErrorBoundary/widgets/NotFound";
import { SnowProvider } from "src/providers/SnowProvider.tsx";
import { RouterWrapper } from "src/widgets";

export const PublicRoutes: NonIndexRouteObject[] = [
  {
    path: "/",
    element: <RouterWrapper />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: (
          <SnowProvider>
            <LandingPage />
          </SnowProvider>
        ),
      },
      {
        path: "outsourcing",
        element: <OutsourcingServicesPage />,
      },
      {
        path: "offer",
        element: <OfferPage />,
      },
      {
        path: "privacy",
        element: <PrivacyPage />,
      },
      {
        path: "/knowledge-base/*",
        element: <KnowledgeBasePage route="base" />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];
